import { useCallback } from 'react';
import { useAppDispatch } from './useAppDispatcher.hook';
import { useAppSelector } from './useAppSelector.hook';
import {
  cancelAssistantAskAction,
  getAssistantIsLoading,
  getAssistantMessages,
} from '../redux/Assistant/Assistant.slice';
import {
  abortAssistantAsk,
  askAssistantThunk,
} from '../redux/Assistant/Assistant.thunk';
import { AssistantAskOrigin } from '../types/assistant.types';

export const useAskAssistant = (origin: AssistantAskOrigin = 'mini-chat') => {
  const dispatch = useAppDispatch();
  const messages = useAppSelector(getAssistantMessages);
  const isLoading = useAppSelector(getAssistantIsLoading);

  const send = useCallback(
    (question: string) => {
      const trimmed = question.trim();

      if (!trimmed || isLoading) {
        return;
      }

      dispatch(askAssistantThunk({ question: trimmed, origin }));
    },
    [dispatch, isLoading, origin],
  );

  const cancel = useCallback(() => {
    abortAssistantAsk();
    dispatch(cancelAssistantAskAction());
  }, [dispatch]);

  return { send, cancel, messages, isLoading };
};
